import { useMemo } from 'react';

export const useVisibleWithSelected = ({
  base = [],
  sliceSize,
  isExpanded = false,
  selectedIndex,
}) => {
  const visibleItems = useMemo(() => {
    if (!base?.length) return [];

    const visible = base.slice(0, sliceSize);

    if (isExpanded) return base;

    if (selectedIndex == null || selectedIndex === -1) return visible;

    const isAlreadyVisible = selectedIndex < sliceSize;

    if (isAlreadyVisible) return visible;

    const selected = base[selectedIndex];

    selected.isForcedSelected = true;

    const replaced = [...visible];
    replaced[replaced.length - 1] = selected;

    return replaced;
  }, [base, sliceSize, isExpanded, selectedIndex]);

  return visibleItems;
};
